import * as Yup from "yup";

export const externalLinkValidationSchema = Yup.object().shape({
  title: Yup.string().required("Title is required.").max(128, "Title cannot exceed 128 characters."),
  description: Yup.string().required("Description is required.").max(256, "Description cannot exceed 256 characters."),
  url: Yup.string().url("Must be a valid URL.").required("URL is required."),
  urlText: Yup.string().required("Button label is required.").max(50, "Button label cannot exceed 50 characters."),
});
